import { render, staticRenderFns } from "./RoundedCorners.vue?vue&type=template&id=7c663820"
import script from "./RoundedCorners.vue?vue&type=script&lang=js"
export * from "./RoundedCorners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports